























import { Component, Vue, Inject, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";

@Component({ components: {} })
export default class SingleApproval extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  currentItem: any = {};
  state: number = 1

  init(item: any){
    this.currentItem = item;
  }

  async save(){
    if(this.currentItem.id){
      await this.$store.dispatch({
        type:"approval/meetingApproval",
        data: {
          meetingAppointmentId : this.currentItem.id,
          approveState : this.state
        }
      })

      this.$emit('save-success');
      this.$emit("input", false);
      this.state = 1;
    }
  }
  cancel(){
    this.state = 1;
    this.$emit("input", false);
  }
  visibleChange(value) {
    if (!value) {
      this.state = 1;
      this.$emit("input", false);
    }
  }
}
